import React from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Link, Pill, Text } from '@maui/elements'
import { formatMediumDate } from '../../utilities/dates'

const Title = ({ artifact, url, children }) => (
  <Box display="flex" gap="16px">
    <Link color='colorActivePrimary' href={url} alt="Open full details" target="_blank" rel="noopener noreferrer">
      <Icon icon="external-link" marginRight='spaceGapMedium' />
      {children}
    </Link>
    {artifact && Array.isArray(artifact) && artifact[0].hashes &&
    <Text color="colorTextDeemphasis">{`(md5: ${artifact[0].hashes.MD5})`}</Text>}
  </Box>
)

Title.propTypes = {
  artifact: PropTypes.array,
  children: PropTypes.node,
  url: PropTypes.string
}

export const Exploit = (props) => {
  const {
    name,
    exploit_url: url,
    atrifact: artifact, // this is (hopefully a temporary measure to correct this type in the API data)
    description,
    disclosure_date: date,
    reliability,
    exploit_type: type
  } = props

  const pillList = []
  if (date) pillList.push(formatMediumDate(date))
  if (type) pillList.push(type)
  if (reliability) pillList.push(reliability)

  return (
    <Box as="li" marginTop="24px" _first={{ marginTop: 0 }}>
      <Title artifact={artifact} url={url}>{name}</Title>
      <Box marginTop="4px" marginBottom="8px">
        {pillList.map((item, i) => (
          <Pill key={i} color="colorTextEmphasis" backgroundColor="colorFillEmphasis">{item}</Pill>
        ))}
      </Box>
      <Text>{description}</Text>
    </Box>
  )
}

Exploit.propTypes = {
  atrifact: PropTypes.array,
  description: PropTypes.string,
  disclosure_date: PropTypes.string,
  exploit_type: PropTypes.string,
  exploit_url: PropTypes.string,
  name: PropTypes.string,
  reliability: PropTypes.string
}

export default Exploit
